module.exports = __webpack_public_path__ + "static/media/soldout.ba34a6b5.png";